var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiskUsageEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "212px",
    height: "80px",
    viewBox: "0 0 212 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-states",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Website",
    transform: "translate(-16.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(16.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(60.000000, 10.000000)",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.25,
    y: 1.25,
    width: 94.5,
    height: 64.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9368421,40.786047 C38.7024384,40.1837164 39.8508327,39.2802205 41.3820252,38.0755593 C41.8594845,37.7081846 42.557193,37.7139885 43.0262589,38.0892369 L45.5354203,40.0965432 C45.6606522,40.1967276 45.84926,40.1907204 45.9668989,40.0828006 L50.3818014,36.0326483 C50.8757934,35.5794689 51.6764399,35.5787726 52.1700955,36.031093 C52.2019959,36.0603223 52.2321646,36.0910984 52.2604719,36.1232892 C54.4519428,38.6754987 55.8037153,40.249787 56.3157895,40.8461538",
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1695565,11.0307692 L19.4579992,11.0307692 L94.1695565,11.0307692 Z M32.7073765,29.4615385 L32.7073765,47.7230769 L32.7073765,29.4615385 Z M62.1210873,48.0076923 L33.2172796,48.0076923 L62.1210873,48.0076923 Z M14.352736,11.0307692 L3,11.0307692 L14.352736,11.0307692 Z",
    id: "lines",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60,16 L60,73 C60,75.209139 61.790861,77 64,77 L153,77 C155.209139,77 157,75.209139 157,73 L157,16 L183,16 C186.865993,16 190,19.581722 190,24 C190,28.418278 186.865993,32 183,32 L205,32 C208.865993,32 212,35.581722 212,40 C212,44.418278 208.865993,48 205,48 L186,48 C182.134007,48 179,51.581722 179,56 C179,60.418278 182.134007,64 186,64 L192,64 C195.865993,64 199,67.581722 199,72 C199,76.418278 195.865993,80 192,80 L140,80 C139.485125,80 138.983234,79.9364709 138.5,79.8158974 C138.016766,79.9364709 137.514875,80 137,80 L46,80 C42.1340068,80 39,76.418278 39,72 C39,67.581722 42.1340068,64 46,64 L7,64 C3.13400675,64 0,60.418278 0,56 C0,51.581722 3.13400675,48 7,48 L47,48 C50.8659932,48 54,44.418278 54,40 C54,35.581722 50.8659932,32 47,32 L22,32 C18.1340068,32 15,28.418278 15,24 C15,19.581722 18.1340068,16 22,16 L60,16 Z M60,15.6687101 C57.1085111,14.6852253 55,11.6240236 55,8 C55,3.581722 58.1340068,0 62,0 L119,0 C122.865993,0 126,3.581722 126,8 C126,8.69059914 125.923432,9.36076016 125.779469,10 L64,10 C61.790861,10 60,11.790861 60,14 L60,15.6687101 Z",
    id: "Combined-Shape",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskUsageEmptyState);
export default __webpack_public_path__ + "static/media/disk_usage_empty_state.a3783a6286e3cf108a886e25df809f59.svg";
export { ForwardRef as ReactComponent };